import React from 'react';
import styled from 'styled-components';

const ControlsContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

const Button = styled.button`
  background-color: white;
  border: none;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f0f0f0;
  }
  
  &:first-child {
    border-bottom: 1px solid #eee;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  
  &:last-child {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
`;

const ZoomLevel = styled.div`
  padding: 5px 0;
  text-align: center;
  border-bottom: 1px solid #eee;
  font-size: 12px;
  color: #666;
`;

const ZoomControls = ({ zoomLevel, onZoomIn, onZoomOut, onReset }) => {
  // Format zoom level as percentage
  const zoomPercentage = Math.round(zoomLevel * 100);
  
  return (
    <ControlsContainer>
      <Button onClick={onZoomIn} title="Zoom In">+</Button>
      <ZoomLevel>{zoomPercentage}%</ZoomLevel>
      <Button onClick={onZoomOut} title="Zoom Out">-</Button>
      <Button onClick={onReset} title="Reset View">⟲</Button>
    </ControlsContainer>
  );
};

export default ZoomControls; 